'use client'
import { useTranslations } from 'next-intl'
import React from 'react'
import { SwiperSlide } from 'swiper/react'

import ZSwiper from '@/_components/universal/swiper/z-swiper'
import { useSectionParams } from '@/_i18n/section-params'

import { AServiceCard, IServiceCardProps, SERVICE_CARD_THEME } from '../services/z-section-services'

const ZSectionOfferedServices = () => {
	const t = useTranslations('health_services')

	const { getSectionParams: getAmbulanceParams } = useSectionParams('ambulances')
	const { getSectionParams: getAmbulanceAnnualProgramParams } = useSectionParams('annualPrograms')
	const { getSectionParams: getPreventiveExaminationsParams } =
		useSectionParams('preventiveExaminations')

	const healthServiceCategories: IServiceCardProps[] = [
		{
			header: t('ambulance_visit.header'),
			title: t('ambulance_visit.title'),
			description: t('ambulance_visit.description'),
			buttonText: t('ambulance_visit.buttonText'),
			link: `/ambulancie/#${getAmbulanceParams('chooseAmbulanceCategory')}`,
			theme: SERVICE_CARD_THEME.BLUE
		},
		{
			header: t('annual_program.header'),
			title: t('annual_program.title'),
			description: t('annual_program.description'),
			buttonText: t('annual_program.buttonText'),
			isFavorite: true,
			link: `/rocne-programy/#${getAmbulanceAnnualProgramParams('chooseProgramCategory')}`,
			theme: SERVICE_CARD_THEME.PURPLE
		},
		{
			header: t('preventive_checkup.header'),
			title: t('preventive_checkup.title'),
			description: t('preventive_checkup.description'),
			buttonText: t('preventive_checkup.buttonText'),
			link: `/preventivne-prehliadky/#${getPreventiveExaminationsParams(
				'choosePreventiveExamination'
			)}`,
			theme: SERVICE_CARD_THEME.TIRQUOIS
		}
	]

	return (
		<div className='max-w-7xl mx-auto mt-12 mb-4 lg:mb-28 px-0 sm:px-6 xl:px-8'>
			<div className='hidden xl:grid xl:grid-cols-3 xl:gap-6'>
				{healthServiceCategories.map((service, index) => (
					<AServiceCard key={index} {...service} />
				))}
			</div>

			<div className='block xl:hidden'>
				<ZSwiper
					spaceBetween={0}
					initialSlidesPerView={1.1}
					breakpoints={{
						640: {
							slidesPerView: 2
						},
						1026: {
							slidesPerView: 3
						}
					}}
				>
					{healthServiceCategories.map((service, index) => (
						<SwiperSlide key={index}>
							<AServiceCard key={index} {...service} />
						</SwiperSlide>
					))}
				</ZSwiper>
			</div>
		</div>
	)
}

export default ZSectionOfferedServices
